<script>
  import ButtonSmall from '../ButtonSmall.svelte';
  import Common from '../../js/common.js';

  export let value;
  export let user;
</script>

<div class='game-prepend'>
  <div class='game-prepend-number'>
    <ButtonSmall value={Common.addZeros(value.number)} link={user?.roles.includes('ROLE_ADMIN') ? `./#/admin/games/${value.number}` : undefined}/>
  </div>

  <div class='game-prepend-time'> {value.time} </div>

  <div class='game-prepend-group'>
    {#if value.group}
      {value.group.toUpperCase()}

      {#if !isNaN(value.group)} <span class='game-prepend-group-ordinal'> {Common.getOrdinal(value.group)} </span> {/if}
    {/if}
  </div>

  {#if value.czechTelevision}
    <a href={value.czechTelevision} class='game-prepend-czech-television'>
      <img class='game-prepend-czech-television-logo' src='img/static/logo/czech-television.png' alt='Czech Television logo'/>
    </a>
  {/if}
</div>

<style>
  .game-prepend {
    display: flex;
    gap: 10px;

    width: 200px;
  }

  .game-prepend-number {
    flex-shrink: 0;

    width: calc(20px / 3 * 4);
  }

  .game-prepend-time {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    width: 45px;
    height: 20px;

    font-weight: bold;
  }

  .game-prepend-group {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    width: 30px;
    height: 20px;
  }

  .game-prepend-group-ordinal {
    height: 20px;

    font-size: 10px;
  }

  .game-prepend-czech-television {
    display: flex;
    justify-content: center;
    align-items: center;

    width: calc(100% - 4px);
    height: 16px;

    padding: 2px;
  }

  .game-prepend-czech-television-logo {
    max-width: 100%;
    max-height: 100%;
  }

  :global(body.dark) .game-prepend-czech-television-logo {
    filter: brightness(88%);
  }

  @media only screen and (max-width: 1300px) and (min-width: 1050px) {
    :global(.schedule-narrow) .game-prepend {
      width: 125px;
    }
  }

  @media only screen and (max-width: 850px) {
    .game-prepend {
      width: 125px;
    }
  }
</style>
